module.exports = __webpack_public_path__ + "static/media/Материали и предложения за решения.40a46f52.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Материали и предложения за решения.pdf
// module id = 111
// module chunks = 0